<div class="eventq-priority-filter-row" role="group" aria-label="Priority filters">
  @for (option of options(); track option.id) {
    <button
      type="button"
      class="eventq-priority-filter-row__toggle"
      [class.eventq-priority-filter-row__toggle--selected]="isFilterSelected(option.id)"
      [class.eventq-priority-filter-row__toggle--unselected]="!isFilterSelected(option.id)"
      [attr.aria-pressed]="isFilterSelected(option.id)"
      (click)="onSelect(option.id)"
    >
      @if (option.iconSrc) {
        <img class="eventq-priority-filter-row__icon" [src]="option.iconSrc | prefixUrl" alt="" />
      }
      <span class="eventq-priority-filter-row__label">{{ option.label }}</span>
    </button>
  }
</div>
